import { Col, Row } from "react-bootstrap";
import ProjectCards from "../../../utils/project-cards";
import { useContent } from "../../../hooks/useContent";
import { useExternalMedia } from "../../../hooks/useExternalMedia";

type Props = {};

const RowTwo = (props: Props) => {
  const {
    truncatedUprise,
    truncatedEraconneckt,
    truncatedMariams,
    truncatedHrTechCms,
    truncatedHrTechSummit,
  } = useContent();

  const { uprise, eraconneckt, mariams, hrtechish, appManagement } = useExternalMedia();

  return (
    <>
      <Row>
        <Col xs={12} md={6} lg={6}>
          <ProjectCards
            cardTitle="Content Management System"
            imgSrc={uprise}
            cardText={truncatedUprise}
            projectName={"Content Management System"}
            link="https://upriseequity.com/"
          />
        </Col>

        <Col xs={12} md={6} lg={6}>
          <ProjectCards
            cardTitle="Applicant Tracking System"
            imgSrc={eraconneckt}
            cardText={truncatedEraconneckt}
            projectName={"Applicant Tracking System"}
            link="http://eraconneckt.com/"
          />
        </Col>

        <Col xs={12} md={6} lg={6}>
          <ProjectCards
            cardTitle="Ecommerce Website"
            imgSrc={mariams}
            cardText={truncatedMariams}
            projectName={"Ecommerce Website"}
            link="https://www.mariamskitchen.nyc/"
          />
        </Col>

        <Col xs={12} md={6} lg={6}>
          <ProjectCards
            cardTitle="Specialized Content Management System"
            imgSrc={hrtechish}
            cardText={truncatedHrTechCms}
            projectName={"Specialized Content Management System"}
            link="https://hrtechish.com/"
          />
        </Col>

        <Col xs={12} md={6} lg={6}>
          <ProjectCards
            cardTitle="Tech Event & Summit Management"
            imgSrc={appManagement}
            cardText={truncatedHrTechSummit}
            projectName={"Tech Event & Summit Management"}
            link="https://hrtechish-frontend.onrender.com/summit"
          />
        </Col>
      </Row>
    </>
  );
};

export default RowTwo;
